import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import EnumRiskLevel from "@wallet-manager/node-types/dist/types/postgres/const/RiskLevel";

import { Itimezone, NotificationSetting } from "../api/types";
import { enumLanguage } from "../utils/constant";
import { RootState } from "./store";

export interface ProfileLoginFace {
  isLogged: boolean;
  featureList: string[];
  appName: string;
  email: string;
  lang: keyof typeof enumLanguage;
  timezone: Itimezone;
  acceptance_level: EnumRiskLevel;
  chain_analysis: boolean;
  appUuid: string;
  merchantId?: string;
  autoSweepExcludedRiskLevels: EnumRiskLevel[] | null;
  notification_setting: NotificationSetting;
}

const initialState: ProfileLoginFace = {
  isLogged: false,
  featureList: [],
  appName: "",
  email: "",
  lang: getBrowserSetting().lang,
  timezone: getBrowserSetting().timezone,
  acceptance_level: EnumRiskLevel.NoAssessment,
  chain_analysis: false,
  appUuid: "",
  merchantId: undefined,
  autoSweepExcludedRiskLevels: [],
  notification_setting: {
    approve_allowance_alert: false,
    offline_sign_alert: false,
  },
};
function getBrowserSetting() {
  const defaultLang = navigator.language || "en";
  const lang = defaultLang.includes("zh")
    ? enumLanguage.zh_cn
    : enumLanguage.en;
  const defaultTimezone = (new Date().getTimezoneOffset() * -1) / 60;
  const timezone = (
    defaultTimezone < 0 ? String(defaultTimezone) : `+${defaultTimezone}`
  ) as Itimezone;
  return { lang, timezone };
}

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Partial<ProfileLoginFace>>) => {
      const {
        appName = "",
        featureList = [],
        email = "",
        acceptance_level = -1,
        chain_analysis = false,
        appUuid = "",
        merchantId = "",
        autoSweepExcludedRiskLevels = [],
      } = action.payload;
      state.isLogged = true;
      state.featureList = featureList;
      state.appName = appName;
      state.email = email;
      state.acceptance_level = acceptance_level;
      state.chain_analysis = chain_analysis;
      state.appUuid = appUuid;
      state.merchantId = merchantId;
      state.autoSweepExcludedRiskLevels = autoSweepExcludedRiskLevels;
    },
    setAccountSetting: (
      state,
      action: PayloadAction<{
        lang: keyof typeof enumLanguage;
        timezone: Itimezone;
        notification_setting: {
          approve_allowance_alert: boolean;
          offline_sign_alert: boolean;
        };
      }>,
    ) => {
      state.lang = action.payload.lang;
      state.timezone = action.payload.timezone;
      state.notification_setting = action.payload.notification_setting;
    },
    logout: (state) => ({ ...initialState, lang: state.lang }),
  },
});

export const { logout, login, setAccountSetting } = profileSlice.actions;

export const selectProfile = (state: RootState) => state.profile;
export const selectExpiryTime = (state: RootState) => {
  // const date = new Date(state.profile.expiryTimeStr);
  // return isValidDate(date) ? date : new Date();
  return new Date();
};
export const selectPermissions = (state: RootState) =>
  state.profile.featureList;

export default profileSlice.reducer;
